import adminApi from "./admin";

export async function getAllAreasWithActions() {
	try {
		const res = await adminApi.get("/areas/with-actions");
		return res.data;
	} catch (error) {
		console.error(error);
		throw new Error("Erro inesperado");
	}
}
